<template>
    <div class="card mb-2" style="background-color: #111;">
        <div class=" d-flex align-items-center justify-content-between ml-2 mr-2">
            <h5 class="mb-1 text-muted font-13 mt-2">{{ historico.autor }}</h5>
            <i class="far fa-trash lixoIcon cursor-pointer font-13" @click="deletar"></i>
        </div>
        <div class="body p-2">
            <div class="d-flex mb-1 flex-column">
                <small style="color: rgba(255, 255, 255, 0.8)" class="font-13">{{ historico.texto }}</small>
            </div>
        </div>
        <div class="card-footer p-1 d-flex justify-content-end" style="text-align: right;">
            <a href="#" class="text-muted font-12 mr-3"><i class="fa fa-thumbs-o-up"></i> {{ new Date(historico.dataCadastro).toLocaleString('pt-br', {minimumFractionDigits: 1, maximumFractionDigits:1,})  }} </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Historico',
    props: ['historico', 'index'],
    methods: {
        deletar : function () {
            this.$emit('deletar', {'id': this.historico.id, 'index': this.index})
        }
    }
}

</script>